import { createSlice } from "@reduxjs/toolkit";
import { IKeywordRecommend } from "api/types/_keyword";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { getListPopularKeywordRecommend, getListRealTimeKeywordRecommend } from "./thunk";


export interface IState {
  realTimeKeywordRecommends: ResponseData<IKeywordRecommend[]> & PaginationResponse | null,
  isRealTimeKeywordRecommendLoading: boolean,
  isRealTimeKeywordRecommendSuccess: boolean,

  popularKeywordRecommends: ResponseData<IKeywordRecommend[]> & PaginationResponse | null,
  isPopularKeywordRecommendLoading: boolean,
  isPopularKeywordRecommendSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  realTimeKeywordRecommends: null,
  isRealTimeKeywordRecommendLoading: false,
  isRealTimeKeywordRecommendSuccess: false,

  popularKeywordRecommends: null,
  isPopularKeywordRecommendLoading: false,
  isPopularKeywordRecommendSuccess: false,

  error: {},
};

const KeywordSlice = createSlice({
  name: "Keyword",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get realtime keyword Recommends
    builder.addCase(getListRealTimeKeywordRecommend.pending, (state: IState, action: any) => {
      state.isRealTimeKeywordRecommendLoading = true
    });
    builder.addCase(getListRealTimeKeywordRecommend.fulfilled, (state: IState, action: any) => {
      state.realTimeKeywordRecommends = action.payload.data;
      state.isRealTimeKeywordRecommendSuccess = true;
      state.isRealTimeKeywordRecommendLoading = false;
    });
    builder.addCase(getListRealTimeKeywordRecommend.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isRealTimeKeywordRecommendSuccess = false;
      state.isRealTimeKeywordRecommendLoading = false;
    });

    //get popular keyword Recommends
    builder.addCase(getListPopularKeywordRecommend.pending, (state: IState, action: any) => {
      state.isPopularKeywordRecommendLoading = true
    });
    builder.addCase(getListPopularKeywordRecommend.fulfilled, (state: IState, action: any) => {
      state.popularKeywordRecommends = action.payload.data;
      state.isPopularKeywordRecommendSuccess = true;
      state.isPopularKeywordRecommendLoading = false;
    });
    builder.addCase(getListPopularKeywordRecommend.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPopularKeywordRecommendSuccess = false;
      state.isPopularKeywordRecommendLoading = false;
    });
  },
});

export default KeywordSlice.reducer;